import { NgModule } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { AuthenticationGuard } from './authentication.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptor } from './http-interceptor';
import { ErrorInterceptor } from './error-interceptor';
import { AktifKullaniciBilgisiService } from './aktif-kullanici-bilgisi.service';
import { RedirectPageService } from './redirect-page.service';
import { LayoutUtilsService } from '@core/utils/layout-utils.service';

export function factory(authenticationService: AuthenticationService) {
	return authenticationService;
}

@NgModule({
	imports: [
	],
	declarations: [
	],
	exports: [
	],
	providers: [
		LayoutUtilsService,
		AuthenticationService,
		AuthenticationGuard,
		AktifKullaniciBilgisiService,
		RedirectPageService,
		{ provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
	]
})
export class AuthenticationModule { }
